
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obchodni-podminky-pro-rk",
      function () {
        return require("private-next-pages/obchodni-podminky-pro-rk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obchodni-podminky-pro-rk"])
      });
    }
  